import { Spiner } from "@components/loaders/spiner";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Form, Input, message, Tabs, TabsProps } from "antd";
import { NoticeType } from "antd/es/message/interface";
import { useEffect, useState } from "react";

export const BiographPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
  });

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    // refetch();
    window.scrollTo(0, 0);
    setAppBar({ title: "Biodata", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Biodata",
    });
  }, [setHeader, setAppBar]);

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Siswa",
      children: (
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <Form.Item label="NIS" name="nis" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="NIS"
                disabled={true}
                // value={watch("nis")}
              />
            </Form.Item>

            <Form.Item label="Nama" name="namasiswa" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Nama"
              />
            </Form.Item>

            <Form.Item
              label="Tempat Lahir"
              name="kotaLahir"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Kota Lahir"
              />
            </Form.Item>

            <Form.Item
              label="Tanggal Lahir"
              name="tanggalLahir"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                type="date"
              />
            </Form.Item>

            <Form.Item label="Asrama" name="asrama" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Asrama"
                disabled={true}
              />
            </Form.Item>

            <Form.Item
              label="Pengasuh Asrama"
              name="waliasrama"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Pengasuh Asrama"
                disabled={true}
              />
            </Form.Item>

            <Form.Item label="Kamar" name="namakamar" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Kamar"
                disabled={true}
              />
            </Form.Item>

            <Form.Item
              label="Musyrif Kamar"
              name="walikamar"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Musyrif Kamar"
                disabled={true}
              />
            </Form.Item>

            {/* <Form.Item label="Kontak Halaqoh" name="" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Kontak Halaqoh"
                disabled={true}
              />
            </Form.Item> */}
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: "Orang Tua",
      children: (
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <Form.Item label="Nama Ayah" name="namaAyah" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Nama Ayah"
              />
            </Form.Item>

            <Form.Item label="Nama Ibu" name="namaIbu" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Nama Ibu"
              />
            </Form.Item>

            <Form.Item
              label="Pekerjaan Ayah"
              name="pekerjaanAyah"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Pekerjaan Ayah"
              />
            </Form.Item>

            <Form.Item
              label="Pekerjaan Ibu"
              name="pekerjaanIbu"
              className="tw-mb-4"
            >
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Pekerjaan Ibu"
              />
            </Form.Item>

            <Form.Item label="Alamat" name="alamat" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Alamat"
              />
            </Form.Item>

            {/* <Form.Item label="No. Telepon" name="telephon" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="No. Telepon"
              />
            </Form.Item> */}
          </div>
        </>
      ),
    },
    {
      key: "3",
      label: "Sekolah",
      children: (
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <Form.Item label="Kelas" name="kelas" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Kelas"
                disabled={true}
              />
            </Form.Item>

            <Form.Item label="Wali Kelas" name="nama" className="tw-mb-4">
              <Input
                className="tw-border-other-0 hover:tw-border-primary-hg tw-shadow-none focus:tw-shadow-none tw-text-base"
                placeholder="Wali Kelas"
                disabled={true}
              />
            </Form.Item>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pb-20">
        <div className="three-tab">
          {isPending ? (
            <div className="tw-text-center">
              <Spiner />
            </div>
          ) : (
            <Form
              className=""
              autoComplete="off"
              initialValues={{
                nis: data?.data?.nis,
                namasiswa: data?.data?.namasiswa,
                kotaLahir: data?.data?.kotalahir,
                tanggalLahir: data?.data?.tanggallahir,
                namaAyah: data?.data?.namaayah,
                namaIbu: data?.data?.namaibu,
                pekerjaanAyah: data?.data?.pekerjaanayah,
                pekerjaanIbu: data?.data?.pekerjaanibu,
                // telephon: data?.data?.telephon,
                alamat: data?.data?.alamat,
                kelas: data?.data?.kelas,
                asrama: data?.data?.asrama,
                namakamar: data?.data?.namakamar,
                waliasrama: data?.data?.waliasrama,
                walikamar: data?.data?.walikamar,
                nama: data?.data?.nama,
              }}
              onFinish={(data) => onUpdateBio(data)}
            >
              <Tabs defaultActiveKey="1" items={items} />
              <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-4">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isPendingUpdateBio}
                  className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
                >
                  {isPendingUpdateBio ? "" : "Update"}
                </Button>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
};
